<template>
  <VSnackbar
    v-model="hasAlert"
    :timeout="snackBarTimeout"
    :color="alertType"
    top
    multi-line
  >
    {{ alertMessage }}
    <VBtn
      depressed
      class=" grey--text text--darken-4"
      @click="hasAlert = false"
    >
      Close
    </VBtn>
  </VSnackbar>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'NetworkSnackBar',
  props: {
    snackBarTimeout: {
      type: Number,
      default: 6000
    }
  },
  computed: {
    ...mapGetters({
      alertType: 'alert/getAlertType',
      alertMessage: 'alert/getAlertMessage' }),
    hasAlert: {
      get: function () {
        return this.alertMessage
      },
      set: function (val) {
        if (!val) {
          this.$store.dispatch('alert/clear')
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
